import { render, staticRenderFns } from "./TrafficDeviations.vue?vue&type=template&id=2465f7db&scoped=true"
import script from "./TrafficDeviations.vue?vue&type=script&lang=js"
export * from "./TrafficDeviations.vue?vue&type=script&lang=js"
import style0 from "./TrafficDeviations.vue?vue&type=style&index=0&id=2465f7db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2465f7db",
  null
  
)

export default component.exports